import {useEffect} from 'react'

const useNoBodyScrollbar = () => useEffect(() => {
    document.body.classList.add('no-scrollbar')

    return () => {
        document.body.classList.remove('no-scrollbar')
    }
})


export default useNoBodyScrollbar
